/* eslint no-extend-native: 0 */
/* eslint array-callback-return: 0 */
/* eslint eqeqeq: 0 */
/* eslint no-mixed-operators: 0 */
/* eslint no-redeclare: 0 */
/* eslint default-case: 0 */
/* eslint no-cond-assign: 0 */
/* eslint no-use-before-define: 0 */
/* eslint radix: 0 */

import { INVENTORY_SEARCHABLE_FIELDS } from '../const/inventorySearchableFields';
import { SEARCH_TYPES } from '../const/searchTypes';
import { INVENTORY_TYPE } from '../const/inventory_types';
import * as QueryParams from '../const/query_params';
import {FLOWER, INFUSED, PREROLL} from "../const/productConstants";

String.prototype.formatMoney = function () {
  if (Number(this)) {
    return Number(this).formatMoney();
  }
  return this;
};

Number.prototype.formatMoney = function () {
  if (this >= 0) {
    return `$${this.formatMoneyDynamic(2, '.', ',')}`;
  }
  return `-$${(this * -1).formatMoneyDynamic(2, '.', ',')}`;
};

Number.prototype.formatMoneyDynamic = function (c, d, t) {
  let n = this;


  var c = isNaN((c = Math.abs(c))) ? 2 : c;


  var d = d == undefined ? '.' : d;


  var t = t == undefined ? ',' : t;


  const s = n < 0 ? '-' : '';


  const i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c))));


  var j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s
    + (j ? i.substr(0, j) + t : '')
    + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`)
    + (c
      ? d
        + Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
};

Number.prototype.padLeft = function (base, chr) {
  const len = String(base || 10).length - String(this).length + 1;
  return len > 0 ? new Array(len).join(chr || '0') + this : this;
};
String.prototype.replaceAll = function (search, replacement) {
  const target = this;
  return target.replace(new RegExp(search, 'g'), replacement);
};
export function getProductIndexBySize(size, productList) {
  // returns product index by size or smallest one
  const products = {};
  productList.map((e, i) => {
    products[e.weight] = i;
  });

  let productIndex = -1;
  if (size in products) {
    productIndex = products[size];
  } else {
    Object.keys(products).sort((a, b) => Number(a) - Number(b));
    // min weight
    if (productList.length > 0) productIndex = 0;
  }
  return Number(productIndex);
}
export function roundSum(value) {
  // return (Math.round(value*2)/2.2).toFixed(2);
  return value.toFixed(2);
}
export function generateUUID() {
  let d = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (
    c,
  ) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}
export const getDate = () => {
  const d = new Date();


  const dformat = [
    (d.getMonth() + 1).padLeft(),
    d.getDate().padLeft(),
    d.getFullYear(),
  ].join('/');
  return dformat;
};

export const getTime12HourFormat = () => {
  var hours = new Date().getHours();
  var hours = (hours + 24) % 24;
  const mins = (hours + 24) % 24;
  let mid = 'am';
  if (hours == 0) {
    // At 00 hours we need to show 12 am
    hours = 12;
  } else if (hours > 12) {
    hours %= 12;
    mid = 'pm';
  }
  return `${hours}:${mins}${mid}`;
};

export function getTime() {
  const d = new Date();


  const dformat = [
    d.getHours().padLeft(),
    d.getMinutes().padLeft(),
    d.getSeconds().padLeft(),
  ].join(':');
  return dformat;
}
export const getTotalProductPrice = (item, menuRoundTax) => item.displayPriceSell;

export const getTotalProductPriceWithCustomTaxes = (item, menuRoundTax) => item.displayPriceSell;

export const priceToFix = (price) => {
  const rounded = Math.round(price * 10) / 10;
  const fixed = rounded.toFixed(1);
  return Number(fixed).toFixed(2);
};

export const bubbleSort = (productList) => {
  const _productList = [...productList];
  let swapped;
  do {
    swapped = false;
    for (let i = 0; i < productList.length - 1; i++) {
      if (productList[i].weight > productList[i + 1].weight) {
        const temp = productList[i];
        productList[i] = productList[i + 1];
        productList[i + 1] = temp;
        swapped = true;
      }
    }
  } while (swapped);
  return _productList;
};

export const productHasSizes = (type, size) => {
  if (size && size.productUnit == 'gram' && type == 'PREROLL') {
    return true;
  }
  return type === 'FLOWER' || type === 'EXTRACT' || type === 'CARTRIDGE';
};

export const titleArray = (ar) => {
  const newTitleArr = [...ar];
  if (ar && ar.length) {
    for (let i = 0; i < ar.length; i++) {
      newTitleArr[i] = titleCase(ar[i]);
    }
  }
  return newTitleArr;
};

export const titleCase = (str) => {
  if (!str || str.length === 0) return '';
  str = str.toLowerCase().split(' ');
  for (let i = 0; i < str.length; i++) {
    str[i] = str[i].split('');
    if (!str[i][0]) continue;
    str[i][0] = str[i][0].toUpperCase();
    str[i] = str[i].join('');
  }
  return str.join(' ');
};

export const getSvgIcon = (categoryName) => {
  switch (categoryName) {
    case 'FLOWER':
      return (
        `${process.env.PUBLIC_URL
        }/assets/img/product-icon-svgs/32x32-flower.svg`
      );
    case 'CARTRIDGE':
      return (
        `${process.env.PUBLIC_URL
        }/assets/img/product-icon-svgs/32x32-cartridge.svg`
      );
    case 'EDIBLE':
      return (
        `${process.env.PUBLIC_URL
        }/assets/img/product-icon-svgs/32x32-edible.svg`
      );
    case 'EXTRACT':
      return (
        `${process.env.PUBLIC_URL
        }/assets/img/product-icon-svgs/32x32-extract.svg`
      );
    case 'MISC':
      return (
        `${process.env.PUBLIC_URL}/assets/img/product-icon-svgs/32x32-misc.svg`
      );
    case 'PREROLL':
      return (
        `${process.env.PUBLIC_URL
        }/assets/img/product-icon-svgs/32x32-preroll.svg`
      );
    case 'PLANT':
      return (
        `${process.env.PUBLIC_URL}/assets/img/product-icon-svgs/32x32-plant.svg`
      );
    case 'TOPICAL':
      return (
        `${process.env.PUBLIC_URL
        }/assets/img/product-icon-svgs/32x32-topical.svg`
      );
    case 'MERCH':
      return (
        `${process.env.PUBLIC_URL}/assets/img/product-icon-svgs/32x32-merch.svg`
      );
    case 'CBD':
      return (
        `${process.env.PUBLIC_URL}/assets/img/product-icon-svgs/32x32-cbd.svg`
      );
    case 'PILL':
      return (
        `${process.env.PUBLIC_URL}/assets/img/product-icon-svgs/32x32-pill.svg`
      );
    case 'METRC':
      return (
        `${process.env.PUBLIC_URL}/assets/img/product-icon-svgs/32x32-metrc.svg`
      );
    case 'BEVERAGE':
      return (
        `${process.env.PUBLIC_URL}/assets/img/product-icon-svgs/32x32-beverage.svg`
      );
    case 'TINCTURE':
      return (
        `${process.env.PUBLIC_URL}/assets/img/product-icon-svgs/32x32-tincture.svg`
      );
    default:
      break;
  }
};

export const getPriority = (categoryName) => {
  switch (categoryName) {
    case 'FLOWER':
      return 1;
    case 'CARTRIDGE':
      return 2;
    case 'EDIBLE':
      return 3;
    case 'EXTRACT':
      return 4;
    case 'MISC':
      return 5;
    case 'PREROLL':
      return 6;
    case 'PLANT':
      return 7;
    case 'TOPICAL':
      return 8;
    case 'MERCH':
      return 9;
    default:
      return 10;
  }
};
export const getIcon = (categoryName) => {
  switch (categoryName) {
    case 'FLOWER':
      return 'assets/img/product-icon-svgs/32x32-flower.svg';
    case 'CARTRIDGE':
      return 'assets/img/product-icon-svgs/32x32-cartridge.svg';
    case 'EDIBLE':
      return 'assets/img/product-icon-svgs/32x32-edible.svg';
    case 'EXTRACT':
      return 'assets/img/product-icon-svgs/32x32-extract.svg';
    case 'MISC':
      return 'assets/img/product-icon-svgs/32x32-misc.svg';
    case 'PREROLL':
      return 'assets/img/product-icon-svgs/32x32-preroll.svg';
    case 'PLANT':
      return 'assets/img/product-icon-svgs/32x32-plant.svg';
    case 'TOPICAL':
      return 'assets/img/product-icon-svgs/32x32-topical.svg';
    case 'MERCH':
      return 'assets/img/product-icon-svgs/32x32-merch.svg';
    default:
      return '';
  }
};
// export const getIcon = (categoryName) => {
//     switch(categoryName) {
//         case 'FLOWER': return 'assets/img/nav-bar-products/flower.png'
//         case 'CARTRIDGE': return 'assets/img/nav-bar-products/cart.png'
//         case 'EDIBLE': return 'assets/img/nav-bar-products/edible.png'
//         case 'EXTRACT': return 'assets/img/nav-bar-products/extract.png'
//         case 'MISC' : return 'assets/img/nav-bar-products/misc.png'
//         case 'PREROLL' : return 'assets/img/nav-bar-products/pre-roll.png'
//         case 'PLANT' : return 'assets/img/nav-bar-products/plant.png'
//         case 'TOPICAL' : return 'assets/img/nav-bar-products/topical.png'
//         case 'MERCH' : return 'assets/img/nav-bar-products/merch.png'
//         default:
//         break;
//     }
// }

export const checkEmpty = value => value || '';

export const getProductName = (product) => {
  if (product.menuTitle) {
    return product.menuTitle;
  } if (product.categoryName) {
    return product.categoryName ? product.categoryName : '';
  } if (product.productName) {
    const firstDigit = product.productName.match(/\d|#/);
    const indexOfFirstDigit = product.productName.indexOf(firstDigit);
    return product.productList
      ? product.productName.substring(0, indexOfFirstDigit)
      : '';
  }
  return '';
};

export const getInfusedProduct = (product) => {
  return (product.type === FLOWER || product.type === PREROLL) && product.subTypes[0] === INFUSED;
}

export const getClassification = (product) => {
  if (!product.classifications.length) return '';
  return checkEmpty(product.classifications[0]);
};

export const getClassificationClass = (p) => {
  const classification = getClassification(p);
  let className = 'hide';
  switch (classification.toLowerCase()) {
    case 'none':
      className = 'organic-class active';
      break;
    case 'kush':
      className = 'kush-class active';
      break;
    case 'hybrid':
      className = 'hybrid-class active';
      break;
    case 'sativa':
      className = 'sativa-class active';
      break;
    case 'indica':
      className = 'indica-class active';
      break;
    case 's/i':
      className = 'si-class active';
      break;
    case 'i/s':
      className = 'indica-hybrid-class active';
      break;
    case 'cbd':
      className = 'cbd-class active';
      break;
  }

  return className;
};

export const getTHC = (description) => {
  if (description[1] && description[1].indexOf('-') > -1) return '';
  return `${description[0]} ${description[1]}`;
};

export const getCannabinoids = (description) => {
  if (description[3] && description[3].indexOf('-') > -1) return '';
  return `${description[2]} ${description[3]}`;
};

export const getTerpenoids = (description) => {
  if (description[5] && description[5].indexOf('-') > -1) return '';
  return `${description[4]} ${description[5]}`;
};

/**
 * decode  numberic values in characters
 */
export const decodeHtmlEntity = function (str) {
  str = str.replace(/</g,"&lt;");
  str = str.replace(/>/g,"&gt;");
  return str.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));
};

/**
 * converts break lines to br tags
 * @param {} str
 * @param {*} is_xhtml
 */
export const nl2br = function (str, is_xhtml) {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  const breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
  return (`${str}`).replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    `$1${breakTag}$2`,
  );
};

export const sliceRewardPoints = (value = '') => {
  if (value[0] === '$') return value.slice(1);
  return value;
};

export const convertProductToCartItem = (product, sizeItem, quantity) => ({
  ...product,
  productId: sizeItem.productId,
  quantity,
  type: product.type,
  brand: product.brand,
  unitsInStock: sizeItem.unitsInStock,
  productName: sizeItem.productName,
  priceSell: sizeItem.priceSell,
  weight: sizeItem.weight,
  terminalId: product.terminalId,
});

const getFilterValues = (values) => {
  return {
    values: values.toUpperCase().split(',')
  }
}

const getMenuSearchSalesChannelFilter = (queryParams) => {
  return queryParams.salesChannelName && queryParams.salesChannelName.toLowerCase();
}

const getMenuSearchFilter = (queryParams) => {
  const searchType = queryParams.searchType && queryParams.searchType.toLowerCase();

  let filters = {};

  if (queryParams.categories || searchType == SEARCH_TYPES.TYPE) {
    filters[INVENTORY_SEARCHABLE_FIELDS.PRODUCT_TYPE] = getFilterValues(queryParams.categories || queryParams.query)
  }

  if (queryParams.brands || searchType == SEARCH_TYPES.BRAND) {
    filters[INVENTORY_SEARCHABLE_FIELDS.BRAND] = getFilterValues(queryParams.brands || queryParams.query);
  }

  if (queryParams.subTypes || searchType == SEARCH_TYPES.SUBTYPE) {
    filters[INVENTORY_SEARCHABLE_FIELDS.SUB_TYPE] = getFilterValues(queryParams.subTypes || queryParams.query);
  }

  if (queryParams.classifications || searchType == SEARCH_TYPES.CLASSIFICATION) {
    filters[INVENTORY_SEARCHABLE_FIELDS.CLASSIFICATION] = getFilterValues(queryParams.classifications || queryParams.query);
  }

  if (queryParams.generals || searchType == SEARCH_TYPES.GENERAL) {
    filters[INVENTORY_SEARCHABLE_FIELDS.GENERALS] = getFilterValues(queryParams.generals || queryParams.query);
  }

  if (queryParams.effects || searchType == SEARCH_TYPES.EFFECT) {
    filters[INVENTORY_SEARCHABLE_FIELDS.EFFECTS] = getFilterValues(queryParams.effects || queryParams.query);
  }

  if (queryParams.flavors || searchType == SEARCH_TYPES.FLAVOR) {
    filters[INVENTORY_SEARCHABLE_FIELDS.FLAVORS] = getFilterValues(queryParams.flavors || queryParams.query);
  }

  if (queryParams.collections || searchType == SEARCH_TYPES.COLLECTION) {
    filters[INVENTORY_SEARCHABLE_FIELDS.COLLECTIONS] = getFilterValues(queryParams.collections || queryParams.query);
  }

  if (queryParams.productId || searchType == SEARCH_TYPES.PRODUCT) {
    filters[INVENTORY_SEARCHABLE_FIELDS.PRODUCT_ID] = {
      value: queryParams.productId
    }
  }

  if (queryParams.maxPrice && !isNaN(queryParams.maxPrice)) {
    filters[INVENTORY_SEARCHABLE_FIELDS.PRICE] = {
      value: queryParams.maxPrice,
      lessThanEqual: true
    }
  }

  if (queryParams.minThc && !isNaN(queryParams.minThc)) {
    filters[INVENTORY_SEARCHABLE_FIELDS.THC_PERCENT] = {
      value: queryParams.minThc,
      greaterThanEqual: true
    }
  }

  return filters;
}

const getMenuSearchSortBy = (queryParams) => {
  let searchType = queryParams.searchType && queryParams.searchType.toLowerCase();
  const query = queryParams.query && queryParams.query.toUpperCase().trim();

  const categoryPriorityAsc = { field: INVENTORY_SEARCHABLE_FIELDS.CATEGORY_PRIORITY };
  const subTypeAsc = { field: INVENTORY_SEARCHABLE_FIELDS.SUB_TYPE };
  const brandAsc = { field: INVENTORY_SEARCHABLE_FIELDS.BRAND };
  const priceDesc = { field: INVENTORY_SEARCHABLE_FIELDS.PRICE, descending: true };
  const productAsc = { field: INVENTORY_SEARCHABLE_FIELDS.MENU_PRODUCT_NAME };

  if (searchType == SEARCH_TYPES.TYPE && query == INVENTORY_TYPE.FLOWER) {
    return {
      ...priceDesc,
      andThen: {
        ...brandAsc,
        andThen: {
          ...productAsc
        }
      }
    }
  }

  switch (searchType) {
    case SEARCH_TYPES.SUBTYPE:
      return {
        ...brandAsc,
        "andThen": {
          ...priceDesc,
          "andThen": {
            ...productAsc
          },
        }
      }
    case SEARCH_TYPES.TYPE:
    case SEARCH_TYPES.BRAND:
    case SEARCH_TYPES.CLASSIFICATION:
    case SEARCH_TYPES.FLAVOR:
    case SEARCH_TYPES.EFFECT:
    case SEARCH_TYPES.GENERAL:
    default:
      return {
        ...categoryPriorityAsc,
        andThen: {
          ...subTypeAsc,
          andThen: {
            ...brandAsc,
            "andThen": {
              ...priceDesc,
              "andThen": {
                ...productAsc
              },
            }
          }
        }
      }
  }
}

export const getMenuSearchDataByQueryParams = (queryParams, strictMedicalCustomerType, tenantId, userId) => {
  const data = {
    filters: getMenuSearchFilter(queryParams),
    sortBy: getMenuSearchSortBy(queryParams),
    strictMedicalCustomerType,
    tenantId,
    userId,
  };

  const salesChannelName = getMenuSearchSalesChannelFilter(queryParams);

  if (salesChannelName) {
    data[QueryParams.SALES_CHANNEL_NAME] = salesChannelName;
  }

  return data;
};

export const truncateProductName = (productName, maxSlugLength) => {
  if (!productName) {
    return productName;
  }

  const delimiter = ' ';
  const slugs = productName.split(delimiter);

  if (slugs.length > 0) {
    return slugs.map((slug) => {
      if (slug.length > maxSlugLength) {
        return `${slug.substring(0, maxSlugLength)}...`;
      }

      return slug;
    }).join(delimiter);
  }

  return productName;
};



// WEBPACK FOOTER //
// ./src/helpers/productHelper.js